import { Button, Center, Stack, Text } from "@mantine/core";
import ScsKeyInject from "./ScsKeyInject";
import KeyInjectTest from "./KeyInjectTest";
import { useWorkEnvironment } from "../contexts/WorkEnvironmentContext";
import { labels } from "../constants/uiActions";

type KeyInjectPageProps = {
  menuTitle?: string;
};

const KeyInjectPage = ({ menuTitle = "" }: KeyInjectPageProps) => {
  const { workEnvironment, openWorkEnvironmentModal } = useWorkEnvironment();

  if (!workEnvironment) {
    return (
      <Center h="100%" mih={320}>
        <Stack align="center" gap="md">
          <Text size="lg" fw={600}>
            {labels.workEnvironmentRequired}
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            VAN과 단말기 모델을 선택한 후 단말기 S/N을 검색할 수 있습니다.
          </Text>
          <Button onClick={openWorkEnvironmentModal}>
            {labels.workEnvironmentSelect}
          </Button>
        </Stack>
      </Center>
    );
  }

  if (workEnvironment.dikYn === "Y") {
    return <KeyInjectTest menuTitle={menuTitle} />;
  }

  return <ScsKeyInject menuTitle={menuTitle} />;
};

export default KeyInjectPage;
